import * as React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Switch,
    TextField,
} from "@mui/material";
import {useTranslation} from "react-i18next";

export interface EditJobPositionDialogProps {
    open: boolean;
    editName: string;
    setEditName: (name: string) => void;
    editActive: boolean;
    setEditActive: (active: boolean) => void;
    editFormErrors: { name?: string };
    setEditFormErrors: React.Dispatch<React.SetStateAction<{ name?: string }>>;
    onClose: () => void;
    onSave: () => void;
}

export default function EditJobPositionDialog({
    open,
    editName,
    setEditName,
    editActive,
    setEditActive,
    editFormErrors,
    setEditFormErrors,
    onClose,
    onSave,
}: Readonly<EditJobPositionDialogProps>): React.ReactElement {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={(_event, reason) => {
                if (reason === "backdropClick") return;
                onClose();
            }}
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>{t('hr.jobs.dialog.editPosition.title')}</DialogTitle>
            <DialogContent>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2, mt: 1}}>
                    <TextField
                        label={t('hr.branches.table.header.name')}
                        fullWidth
                        size="small"
                        required
                        value={editName}
                        onChange={(e) => {
                            setEditName(e.target.value);
                            setEditFormErrors((p) => ({...p, name: undefined}));
                        }}
                        error={!!editFormErrors.name}
                        helperText={editFormErrors.name}
                    />
                    <FormControlLabel
                        control={<Switch checked={editActive} onChange={(e) => setEditActive(e.target.checked)}
                                         color="primary"/>}
                        label={t('common.status.active')}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common.actions.cancel')}</Button>
                <Button variant="contained" onClick={onSave}>{t('common.actions.save')}</Button>
            </DialogActions>
        </Dialog>
    );
}
